<template>
  <div class="container-fluid">
    <div style="margin-bottom: 6px">
      <div>
        <div style="float: left;margin-top: 6px;margin-bottom: 6px">
          <b>{{total}}</b> Production Batch
        </div>
        <div style="float: right;margin-top: 6px;margin-bottom: 6px">
          <button class="btn btn-sm btn-primary" @click="toAdd()">New Production Batch</button>
        </div>
      </div>
      <el-table v-tb-height="{bottom:40,self:this}" ref="table" :height="height" border :data="list" empty-text="Temporarily no data">
        <el-table-column label="Batch No" min-width="100px">
          <template slot-scope="scope">
            {{scope.row.p_type+scope.row.p_batchNo}}
          </template>
        </el-table-column>
        <el-table-column prop="p_count" label="ID assigned"></el-table-column>
        <el-table-column prop="p_date" label="Date" min-width="150px">
          <template slot-scope="scope">
            {{new Date(scope.row.p_date*1000)}}
          </template>
        </el-table-column>
        <el-table-column prop="p_description" label="Description" min-width="200px">
          <template slot-scope="scope">
            {{scope.row.p_description}}
            <a v-on:click="editDesc(scope.row)"><i class="el-icon-s-data update"></i>Edit</a>
          </template>
        </el-table-column>
        <el-table-column min-width="150px" label="Operator">
          <template slot-scope="scope">
            <a v-on:click="toDelete(scope.row)"><i class="el-icon-delete delete"></i>Delete</a>
            <!--            <a v-on:click="toDownload(scope.row)"><i class="el-icon-download update"></i>Download</a>-->
            <a :href='`/api/v1/web/production/download?p_id=${scope.row.p_id}`'><i class="el-icon-download update"></i>Download</a>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div align="right">
      <div class="block">
        <el-pagination
          @current-change="handleCurrentChange"
          layout="prev, pager, next"
          :current-page="pageIndex"
          :page-size="pageSize"
          :total="total">
        </el-pagination>
      </div>
    </div>

    <el-dialog
      :title="dialogName"
      :visible.sync="dialogVisible"
      destroy-on-close
      width="400px"
    >
      <ProductionAdd @closeDialog="closeDialog"></ProductionAdd>
    </el-dialog>

    <el-dialog
      title="Edit Description"
      :visible.sync="editVisible"
      :destroy-on-close="true"
      width="400px"
    >
      <ProductionEdit v-if="editVisible" @closeDialog="closeEdit" :chooseItem="chooseItem"></ProductionEdit>
    </el-dialog>

  </div>
</template>

<script>
  import ProductionAdd from './ProductionAdd'
  import ProductionEdit from './ProductionEdit'

  export default {
    name: 'ProductionManage',
    components: {ProductionAdd,ProductionEdit},
    data () {
      return {
        list: [],

        chooseItem: null,
        isEdit: true,
        dialogName: '',
        pageIndex: 1,
        pageSize: 20,
        total: 0,//400
        dialogVisible: false,
        editVisible: false,
        height: 0
      }
    },
    created () {
      this.getData()
    },
    mounted () {
    },
    methods: {
      getData () {
        this.$api.rootV1.post('/web/production/list', {page: this.pageIndex, size: this.pageSize}, (res) => {
          this.list = res.data
          this.total = res.totalCount
        })
      },
      toAdd () {
        this.dialogName = 'Add product'
        this.dialogVisible = true
      },
      closeDialog () {
        this.dialogVisible = false
        this.getData()
      },
      editDesc(row){
        this.chooseItem = row
        this.editVisible = true
      },
      closeEdit () {
        this.getData()
        this.editVisible = false
      },
      toDownload (row) {
        location.href = `/web/production/download?p_id=${row.p_id}`
      },
      toDelete (row) {
        this.$confirm('This operation will delete the product, do you want to continue?', 'prompt', {
          confirmButtonText: 'Confirm',
          cancelButtonText: 'Cancel',
          type: 'warning'
        }).then(async () => {
          this.doDelete(row)
        }).catch(() => {
          this.$message({
            type: 'info',
            message: 'cancelled!'
          })
        })
      },
      doDelete (row) {
        let loading = this.$util.loading()
        this.$api.rootV1.post('/web/production/delete', {p_id: row.p_id},
          (res) => {
            this.$message.success('successfully deleted!')
            this.getData()
            loading.close()
          },
          (res) => {
            this.$message.error('failed to delete!')
            loading.close()
          })
      },
      handleCurrentChange (val) {
        console.log(`当前页: ${val}`)
        this.pageIndex = val
        this.getData()
      },
    },
    watch: {}
  }
</script>

<style scoped>
  .a {
    position: relative;
    left: 10px;
  }
</style>




// WEBPACK FOOTER //
// src/components/main/productionManage/ProductionManage.vue